import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '/img/logo.png';

export default function Header() {
	const [menuOpen, setMenuOpen] = useState(false);
	const shortcutData = [
	  { title: "Home", link: "/" },
	  { title: "Available Job", link: "/" },
	  { title: "Registration", link: "/registration" },
	  { title: "Login", link: "/login" },
	];
  return (
    <header className="relative z-50 bg-gradient-to-r from-[#1A2B63] via-[#0E1B40] to-[#1A2B63] shadow-xl">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
        {/* Left: Logo */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex items-center space-x-3"
        >
          <img src={logo} alt="IIUC Logo" className="h-14 w-auto drop-shadow-lg" />
          <div className="text-white font-bold text-lg tracking-wide hidden sm:block">
            International Islamic University Chittagong
          </div>
        </motion.div>

        {/* Desktop Menu */}
        <motion.nav
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="hidden md:flex space-x-8 text-white font-medium text-base"
        >
          {shortcutData.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="relative group"
            >
              <span className="group-hover:text-[#FFD700] transition-colors duration-300">
                {item.title}
              </span>
              <span className="absolute left-0 bottom-[-4px] w-0 h-[2px] bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}
        </motion.nav>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white focus:outline-none"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-[#0E1B40] text-white px-6 py-4 space-y-3 border-t border-white/10"
          >
            {shortcutData.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                onClick={() => setMenuOpen(false)}
                className="block py-2 text-lg hover:text-[#FFD700] transition-colors duration-300"
              >
                {item.title}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Animated Background Accent */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.18 }}
        transition={{ duration: 1.2 }}
        className="absolute inset-0 pointer-events-none"
        style={{ backgroundImage: "radial-gradient(circle at 10% 20%, rgba(255,215,0,0.08), transparent 10%), radial-gradient(circle at 90% 80%, rgba(255,255,255,0.02), transparent 15%)" }}
      ></motion.div>
    </header>
  );
}
